export default __webpack_public_path__ + "static/media/premium-iphone.70cb375b.png";